export const CONTAINER_SIZE_FLUID = 'fluid';
export const CONTAINER_SIZE_DEFAULT = 'default';
export const CONTAINER_SIZE_NARROW = 'narrow';
export const CONTAINER_SIZE_TINY = 'tiny';
export const CONTAINER_SIZE_HALF = 'half';
